import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tokens.css';
import './styles/ui.css';
import './index.css';
import App from './App';
import VersionFooter from './components/VersionFooter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <VersionFooter />
    </BrowserRouter>
  </React.StrictMode>
);